import { useState } from "react";
import ReactPaginate from "react-paginate";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import { Button } from "../ui";

function Pagination({ lengthofItems, onPageChange, limit, currentPage }) {
  const [value, setValue] = useState({
    selected: currentPage + 1,
  });

  const handleValueChange = (e) => {
    setValue({ selected: e.target.value });
  };

  const handleInputPageChange = (e) => {
    e.preventDefault();
    onPageChange({
      selected: parseInt(value.selected) - 1,
    });
    return;
  };

  return (
    <div className="flex flex-wrap space-y-5 items-center justify-between sm:space-y-0 md:flex-nowrap md:space-x-5 lg:space-y-0 xl:space-y-0">
      <ReactPaginate
        breakLabel="..."
        nextLabel={<GoChevronRight className="w-4 h-4 text-primary" />} // custom next
        previousLabel={<GoChevronLeft className="w-4 h-4 text-primary" />} // custom prev
        onPageChange={onPageChange}
        pageRangeDisplayed={50}
        pageCount={Math.ceil(lengthofItems / limit)}
        renderOnZeroPageCount={null}
        containerClassName="flex items-center justify-center space-x-2"
        pageLinkClassName="pageNumber"
        previousLinkClassName="pageNumber"
        nextLinkClassName="pageNumber"
        activeLinkClassName="selectedPageNumber"
        disabledClassName="lastPage"
        disabledLinkClassName="lastPage"
        forcePage={currentPage}
      />

      <div>
        <form onSubmit={handleInputPageChange} className="flex items-center">
          <label className="mr-2">Go To:</label>
          <input
            min={1}
            max={Math.ceil(lengthofItems / limit)}
            type="number"
            onChange={handleValueChange}
            className="border py-1 px-3 min-w-[2rem] max-w-[5rem] ml-2 rounded-lg appearance-none"
            value={value.selected}
          />
          <Button type="submit" className={"ml-2"}>
            Go
          </Button>
        </form>
      </div>
    </div>
  );
}

export default Pagination;
